import { AbsenceManagement } from '@/modules/companies'
import { useParam } from '@/utils'

export function ChildcareCard() {
  const userId = useParam('userId')

  return <AbsenceManagement domain="user-profile" userId={userId} />
}
